import { render, staticRenderFns } from "./list_products_component.vue?vue&type=template&id=3fc967d1&scoped=true"
import script from "./list_products_component.vue?vue&type=script&lang=js"
export * from "./list_products_component.vue?vue&type=script&lang=js"
import style0 from "./list_products_component.vue?vue&type=style&index=0&id=3fc967d1&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fc967d1",
  null
  
)

export default component.exports